import React from 'react';

import LogsProvider from './index';

export const withLogsContext = WrappedComponent => props => <LogsProvider><WrappedComponent {...props} /></LogsProvider>